Ext.define('SA.view.report.HideCountryMenuItem', {
    alias: 'widget.menu-hide-country',
    extend: 'Ext.menu.Item',

    beforeMenuShow() {
        var reportModel = this.getReportModel();

        if (reportModel.hasCountry()) {
            this.setText(this.getHideText());
        }
        else {
            this.setText(this.getShowText());
        }
    },

    getHideText() {
        var country = this.getReportModel().getCountry();

        return 'Remove ' + SA.Institution.getCountry(country).getName() + ' from Report';
    },

    getReportModel() {
        return this.projectView;
    },

    getShowText() {
        var country = this.getReportModel().getCountry();

        return 'Add ' + SA.Institution.getCountry(country).getName() + ' to Report';
    },

    handler() {
        var reportModel = this.getReportModel(),
            country = SA.Institution.getCountry(reportModel.getCountry()).getLocationSeries();

        if (reportModel.hasCountry()) {
            reportModel.removeLocation(country);
        }
        else {
            reportModel.addLocation(country);
        }

        reportModel.save();
    }
});
